export default "__VITE_ASSET__DGJU3RdS__"